/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicRefreshUtilizationSummary extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicRefreshUtilizationSummary");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicRefreshUtilizationSummary.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicRefreshUtilizationSummary>): BackgroundJobPayloadForPeriodicRefreshUtilizationSummary {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicRefreshUtilizationSummary(), model);
        BackgroundJobPayloadForPeriodicRefreshUtilizationSummary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicRefreshUtilizationSummary>): BackgroundJobPayloadForPeriodicRefreshUtilizationSummary {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicRefreshUtilizationSummary.newInstance(<BackgroundJobPayloadForPeriodicRefreshUtilizationSummary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicRefreshUtilizationSummary) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicRefreshUtilizationSummary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicRefreshUtilizationSummary): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicRefreshUtilizationSummary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
